// P1 效果文本解析：从 effectText / 技能描述中提取数值
// P2 将扩展为完整 effect handler 注册表
import type { DamageType } from "@/types/cards";
import type { HeroSkill } from "@/types/heroes";

// 技能描述中的伤害：【25f】/【30sf】/【10ss】等
export function parseSkillDamage(
  description: string
): { amount: number; dtype: DamageType } | null {
  const m = description.match(/【(\d+)(f|sf|ss|w|hw)】/);
  if (!m) return null;
  return { amount: parseInt(m[1], 10), dtype: m[2] as DamageType };
}

// 英雄主动技能中可用于 P法术/S法术 的伤害技能
export function findDamageSkill(
  skills: HeroSkill[],
  skillName?: string
): { skill: HeroSkill; amount: number; dtype: DamageType } | null {
  for (const s of skills) {
    if (s.type !== "active") continue;
    if (skillName && s.name !== skillName) continue;
    const dmg = parseSkillDamage(s.description);
    if (dmg) return { skill: s, ...dmg };
  }
  return null;
}

// 补给牌恢复量："恢复10点生命" / "恢复5点生命、10点魔法" / "恢复15点魔法"
export function parseSupplyHeal(effectText: string): { hp?: number; mp?: number } {
  const out: { hp?: number; mp?: number } = {};
  const hp = effectText.match(/恢复(\d+)点生命/);
  if (hp) out.hp = parseInt(hp[1], 10);
  const mp = effectText.match(/(\d+)点魔法/);
  if (mp) out.mp = parseInt(mp[1], 10);
  return out;
}

// 摄魂牌汲取量："汲取目标10点生命" / "汲取目标15点魔法"
export function parseSoulAmount(effectText: string): number {
  const m = effectText.match(/汲取目标(\d+)点/);
  return m ? parseInt(m[1], 10) : 0;
}

// 响应牌名 → 响应类型（效果牌以名字精确匹配）
export const RESPONSE_CARD_NAMES = [
  "闪避",
  "虚灵",
  "反射",
  "无敌",
  "解除",
  "拒援",
] as const;

export function responseKindOfCard(cardName: string): string | null {
  return (RESPONSE_CARD_NAMES as readonly string[]).includes(cardName)
    ? cardName
    : null;
}
